{
  "billing": {
    "full": {
      "label": "فاتورة كاملة",
      "description": "فقط في حال دفعت الوكالة قيمة الحجز للشريك — تشمل قيمة الحجز + رسوم الخدمة في بندين"
    },
    "feeOnly": {
      "label": "رسوم الخدمة فقط",
      "description": "العميل يدفع للشريك مباشرة — تشمل الفاتورة رسوم الخدمة فقط"
    },
    "amountHint": "مطلوبة فقط في الفاتورة الكاملة (عندما تدفع الوكالة قيمة الحجز للشريك)",
    "amountRequired": "مطلوبة في الفاتورة الكاملة (الوكالة دفعت قيمة الحجز للشريك)",
    "onlyEnabled": "الوضع الوحيد المفعّل في الإعدادات"
  },
  "list": {
    "title": "الحجوزات",
    "subtitle": "{{n}} حجزاً",
    "exportCsv": "تصدير CSV",
    "newBooking": "حجز جديد",
    "filterByStatus": "تصفية حسب الحالة",
    "all": "الكل",
    "search": "بحث",
    "searchPlaceholder": "رقم الحجز، رقم التأكيد، العميل، الجوال",
    "coordinator": "المنسق",
    "allCoordinators": "كل المنسقين",
    "noCoordinator": "بدون منسق",
    "period": "الفترة",
    "periods": {
      "all": "كل الفترات",
      "thisMonth": "هذا الشهر",
      "lastMonth": "الشهر الماضي",
      "custom": "فترة مخصصة"
    },
    "from": "من",
    "to": "إلى",
    "caption": "قائمة الحجوزات",
    "empty": "لا توجد حجوزات مطابقة",
    "clearFilters": "مسح الفلاتر",
    "columns": {
      "reference": "رقم الحجز",
      "customer": "العميل",
      "partner": "الشريك",
      "coordinator": "المنسق",
      "bookingAmount": "قيمة الحجز",
      "fee": "الرسم",
      "invoice": "الفاتورة",
      "status": "الحالة",
      "date": "التاريخ"
    },
    "mode": {
      "full": "كاملة",
      "feeOnly": "رسوم فقط"
    }
  },
  "form": {
    "newTitle": "حجز جديد",
    "editTitle": "تعديل {{reference}}",
    "cancel": "إلغاء",
    "unsavedConfirm": "لديك تغييرات غير محفوظة. إلغاء؟",
    "toast": {
      "saved": "تم حفظ التعديلات",
      "confirmed": "تم تأكيد الحجز",
      "draftSaved": "تم حفظ المسودة"
    },
    "saveFailed": "تعذر الحفظ",
    "errors": {
      "required": "هذا الحقل مطلوب",
      "chooseCustomer": "اختر العميل",
      "choosePartner": "اختر الشريك",
      "feePositive": "يجب أن يكون الرسم أكبر من صفر"
    },
    "feeRulePercent": "{{value}}% من قيمة الحجز",
    "partiesPanel": "أطراف الحجز",
    "customer": "العميل",
    "customerPlaceholder": "ابحث بالاسم أو الجوال",
    "customerSearch": "اسم العميل أو رقم الجوال",
    "customerEmpty": "لا يوجد عملاء مطابقون",
    "newCustomer": "عميل جديد",
    "partner": "الشريك",
    "partnerPlaceholder": "اختر الشريك",
    "partnerSearch": "اسم الشريك",
    "partnerEmpty": "لا يوجد شركاء نشطون",
    "partnerConfirmation": "رقم تأكيد الشريك",
    "optional": "اختياري",
    "notes": "ملاحظات",
    "notesHint": "اختيارية — لا تظهر للعميل أو المنسق",
    "amountsPanel": "المبالغ والفاتورة والمنسق",
    "bookingAmount": "قيمة الحجز (ر.س)",
    "feeAmount": "رسوم الخدمة (ر.س)",
    "feeDefault": "الافتراضي من الإعدادات: {{rule}}",
    "coordinator": "المنسق",
    "coordinatorAgreement": "اتفاقية {{name}}: {{agreement}} من الرسم",
    "noAgreement": "لا توجد اتفاقية سارية لهذا المنسق",
    "directBooking": "حجز مباشر بدون منسق",
    "none": "بدون",
    "billingMode": "وضع الفاتورة",
    "summary": {
      "title": "ملخص الحساب",
      "fee": "رسوم الخدمة",
      "coordinatorShare": "حصة المنسق",
      "coordinatorShareRule": "حصة المنسق ({{rule}})",
      "capped": "الحصة الثابتة أكبر من الرسم وتم تحديدها بقيمة الرسم",
      "net": "صافي المنشأة"
    },
    "invoice": {
      "title": "فاتورة العميل",
      "bookingLine": "قيمة الحجز",
      "feeLine": "رسوم الخدمة",
      "vat": "ضريبة القيمة المضافة ({{rate}}%)",
      "total": "الإجمالي على العميل",
      "empty": "أدخل المبالغ لعرض الفاتورة.",
      "note": "تُصدر الفاتورة بعد التأكيد من صفحة الحجز، وتصل العميل برسالة SMS مع رابط دفع StreamPay."
    },
    "saving": "جاري الحفظ…",
    "saveChanges": "حفظ التعديلات",
    "confirm": "تأكيد الحجز",
    "save": "حفظ",
    "saveDraft": "حفظ كمسودة",
    "newCustomerDialog": {
      "title": "عميل جديد",
      "description": "يُضاف العميل ويُختار في الحجز مباشرة."
    }
  },
  "detail": {
    "title": "حجز · {{partner}}",
    "toast": {
      "confirmed": "تم تأكيد الحجز",
      "cancelled": "تم إلغاء الحجز",
      "invoiceIssued": "تم إصدار الفاتورة، جاري الإرسال إلى StreamPay"
    },
    "suffix": {
      "paymentFailed": "فشل الدفع",
      "awaitingPayment": "بانتظار الدفع"
    },
    "fields": {
      "partner": "الشريك",
      "partnerConfirmation": "رقم تأكيد الشريك",
      "createdBy": "أنشأه"
    },
    "actions": {
      "edit": "تعديل",
      "cancelDraft": "إلغاء المسودة",
      "cancelBooking": "إلغاء الحجز",
      "confirm": "تأكيد الحجز",
      "issueInvoice": "إصدار الفاتورة"
    },
    "cancelDialog": {
      "title": "إلغاء الحجز {{reference}}؟",
      "description": "لا تُحذف الحجوزات، تبقى في السجل بحالة ملغي وتُلغى عمولة المنسق المعلّقة.",
      "confirm": "إلغاء الحجز"
    },
    "banner": {
      "cancelled": "أُلغي هذا الحجز في {{at}}.",
      "refunded": "استُرد مبلغ هذا الحجز بالكامل في {{at}} وعُكست عمولة المنسق."
    },
    "detailsPanel": "تفاصيل الحجز",
    "notes": "ملاحظات",
    "customerPanel": "العميل",
    "noEmail": "لا يوجد بريد",
    "streampayLinked": "مرتبط بعميل StreamPay",
    "feesPanel": "الرسوم والعمولة",
    "fee": "رسوم الخدمة",
    "bookingAmount": "قيمة الحجز",
    "noCoordinator": "بدون منسق",
    "net": "صافي المنشأة",
    "commission": {
      "pending": "العمولة معلّقة وتصبح مستحقة عند دفع الفاتورة.",
      "earned": "العمولة مستحقة للمنسق.",
      "paid": "حُوّلت العمولة للمنسق.",
      "reversed": "عُكست العمولة بسبب الاسترداد.",
      "snapshot": "الاتفاقية محفوظة مع الحجز كما كانت وقت التأكيد."
    },
    "eventsPanel": "سجل الأحداث",
    "invoice": {
      "toast": {
        "resendCopied": "تم نسخ رابط الدفع — شاركه مع العميل (StreamPay لا يدعم إعادة الإشعار تلقائياً)",
        "cancelled": "تم إلغاء الفاتورة",
        "retried": "تمت إعادة المحاولة",
        "linkCopied": "تم نسخ رابط الدفع"
      },
      "cancelledTitle": "أُلغيت الفاتورة {{number}}",
      "notIssued": "لم تُصدر فاتورة بعد",
      "heading": "الفاتورة",
      "modeFull": "فاتورة كاملة",
      "modeFeeOnly": "رسوم فقط",
      "meta": "{{mode}} · صدرت عبر StreamPay · تستحق في {{due}}",
      "caption": "بنود الفاتورة",
      "columns": {
        "item": "البند",
        "quantity": "الكمية",
        "amount": "المبلغ"
      },
      "vat": "ضريبة القيمة المضافة ({{rate}}%)",
      "total": "الإجمالي",
      "sending": "جاري الإرسال إلى StreamPay…",
      "sendFailed": "تعذر إرسال الفاتورة إلى StreamPay",
      "sendFailedWithError": "تعذر إرسال الفاتورة إلى StreamPay: {{error}}",
      "paymentFailed": "فشلت محاولة الدفع الأخيرة. الفاتورة ما زالت مفتوحة ويمكن للعميل الدفع مجدداً.",
      "paid": "دُفعت الفاتورة في {{at}}.",
      "paymentLink": "رابط الدفع",
      "copyLink": "نسخ الرابط",
      "resend": "إعادة الإرسال",
      "cancel": "إلغاء الفاتورة",
      "cancelDialog": {
        "title": "إلغاء الفاتورة {{number}}؟",
        "description": "لن يتمكن العميل من الدفع عبر الرابط، ويعود الحجز إلى حالة مؤكد.",
        "confirm": "إلغاء الفاتورة"
      }
    }
  }
}
